import React, { useEffect, useRef } from "react";
import * as DataService from "../../firebase/DataService";
import ModelViewerElement from "../../components/model-viewer-element/ModelViewerElement";
import { createStyles, makeStyles } from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useDispatch } from "react-redux";
import { updateAnnotations } from "../../store/slices/AnnotationSlice";
import { setHotspotStyle } from "../../store/slices/CustomizerSlice";

const useStyles = makeStyles(() =>
  createStyles({
    modelViewer: {
      height: "100%",
      width: "100%",
    },
    backdrop: {
      zIndex: 101,
    },
    poweredLogo: {
      position: "fixed",
      zIndex: "101",
      bottom: "1rem",
      right: "1rem",
      padding: "1rem",
      color: "#ffff",
      background: "rgba(0,0,0,0.8)",
      WebkitBackdropFilter: "saturate(180%) blur(20px)",
      backdropFilter: "saturate(180%) blur(20px)",
      borderRadius: "1rem",
    },
  })
);

const View = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const modelViewer = useRef(null);

  const uid = props.match.params.id;
  const [configMap, setConfigMap] = React.useState("");
  const [isFetching, setIsFetching] = React.useState(true);

  //TODO: refactor for state
  useEffect(() => {
    async function fetchModelViewerConfig() {
      return await DataService.fetchCollectionById("models", uid);
    }
    fetchModelViewerConfig().then((configMap) => {
      const configData = JSON.parse(configMap.configMap);
      setConfigMap(configData);
      dispatch(updateAnnotations(configData.annotations.annotations));
      dispatch(setHotspotStyle(configData.customizer.hotspotStyle));
      setIsFetching(false);
    });
  }, []);

  return (
    <>
      <Backdrop className={classes.backdrop} open={isFetching}>
        <CircularProgress color="primary" />
      </Backdrop>

      {!isFetching && (
        <>
          <ModelViewerElement
            ref={modelViewer}
            style={classes}
            environmentImage={configMap.environment.environmentImage.src}
            src={configMap.model.model.src}
            background={configMap.customizer.hotspotStyle.background}
            useSkybox={configMap.environment.useSkybox}
          />
          <div className={classes.poweredLogo}>Powered by XR Central</div>
        </>
      )}
    </>
  );
};

export default View;
